$(document).ready(function () {
  // Product create/edit form: fill the EAN field from the camera
  $(document).on('click', '#ean-scan-button', function (e) {
    e.preventDefault();
    const $button = $(this);
    CameraBarcodeScanner.open($button, {
      onDetected: function (code) {
        $('#ean-input').val(code).trigger('input').trigger('change');
        CameraBarcodeScanner.close().then(function () {
          showToast({
            type: 'success',
            title: '',
            message: `${$button.data('scanned-text')}: ${code}`,
            position: 'bottom-center',
            duration: 2500,
          });
        });
      },
    });
  });
});
